// extracted by mini-css-extract-plugin
export default {"panel":"DesktopAboutUsPanel_panel__RmOFN"};